import React from 'react'
import {
  LanguageSelect,
  LocaleCodes,
  LocaleCodesSlugPrefix,
} from '../../constants/localization.constants'
import { returnSelectedLocaleData } from '../../utils/functions.utils'
import CustomNav from '../global/customNav'
import FullHeader from '../global/fullHeader'
import Header from '../global/header'
import headerStaticQuery from '../global/header/headerStaticQuery'
import MinHeader from '../global/minHeader'
import minHeaderStaticQuery from '../global/minHeader/minHeaderStaticQuery'

const RenderHeader = ({ headerData, mainNavBannerData, minimalHeader, customNav, locale }: any) => {
  const lang = locale ? locale : LocaleCodes.ENGLISH.code
  const localeInfo =
    LanguageSelect.rows.find((localeObj: any) => {
      return localeObj.lang === LocaleCodesSlugPrefix[locale]
    }) || LanguageSelect.rows[0]
  const uiPathSrc = localeInfo.href + '/'

  // Header Data
  const staticQueryHeaderData = headerStaticQuery.allContentfulNavMenu()?.allContentfulNavMenu
  const navDataList = headerData ? headerData.allContentfulNavMenu : staticQueryHeaderData
  const localizedNavData = returnSelectedLocaleData(navDataList?.nodes || [], lang)
  const selectedNavData =
    localizedNavData?.find((nav: any) => {
      return nav?.location?.startsWith('New ') || nav?.location?.startsWith('V3 ')
    }) ||
    (localizedNavData && localizedNavData[0]) ||
    null

  // MinHeader Data
  const staticQueryMinHeaderData = minHeaderStaticQuery.allContentfulNavMenu()?.allContentfulNavMenu
  const minNavDataList = headerData ? headerData.allContentfulNavMenu : staticQueryMinHeaderData
  const langMinNavData = minNavDataList?.nodes?.filter(
    (navData: any) => navData?.node_locale === locale
  )
  const selectedMinNavData =
    langMinNavData?.find((nav: any) => {
      return nav?.location?.startsWith('New ') || nav?.location?.startsWith('V3 ')
    }) ||
    (langMinNavData && langMinNavData[0]) ||
    null

  if (customNav) return <CustomNav headerData={customNav} />

  if (minimalHeader)
    return locale !== LocaleCodes.ENGLISH.code ? (
      <MinHeader headerData={selectedNavData} uiPathSrc={uiPathSrc} />
    ) : locale === LocaleCodes.ENGLISH.code ? (
      <MinHeader headerData={selectedNavData} uiPathSrc={uiPathSrc} />
    ) : (
      <MinHeader headerData={selectedMinNavData} uiPathSrc={uiPathSrc} />
    )

  return selectedNavData?.location?.startsWith('New ') ||
    selectedNavData?.location?.startsWith('V3 ') ||
    selectedNavData?.location === null ||
    selectedNavData?.location === undefined ? (
    <FullHeader headerData={selectedNavData} uiPathSrc={uiPathSrc} />
  ) : (
    <Header
      headerData={headerData}
      mainNavBannerData={mainNavBannerData}
      locale={locale}
      uiPathSrc={uiPathSrc}
    />
  )
}

export default RenderHeader
